import AjaxUtils from './ajaxUtils';

const prospectingCompaniesUrl = '/api/lusha-prospecting/companies';

const searchCompaniesByName = async companyData => AjaxUtils.post(prospectingCompaniesUrl, companyData);

const prospectingEmployeesUrl = '/api/lusha-prospecting/employees';

const searchEmployeesByCompany = async companyData => AjaxUtils.post(prospectingEmployeesUrl, companyData);

export {
  searchCompaniesByName,
  searchEmployeesByCompany,
};
